import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorldPayCardPaymentComponent } from './world-pay-card-payment.component';

@NgModule({
  declarations: [WorldPayCardPaymentComponent],
  exports: [WorldPayCardPaymentComponent],
  imports: [CommonModule],
})
export class WorldPayCardPaymentModule {}
